import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { escucharInstalacion } from './hooks/useInstalacion';

// El navegador avisa una sola vez por carga de página que la app se puede
// instalar (evento beforeinstallprompt) — hay que escucharlo antes de que
// cualquier componente lo necesite, independiente de que no se use Service
// Worker (ver comentario de abajo: son cosas distintas, instalar la PWA no
// requiere un SW).
escucharInstalacion();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Esta app siempre necesita el backend vivo (gestión de turnos/pacientes en
// tiempo real) — no hay un caso de uso offline real, así que no se registra
// ningún service worker. Se desregistra cualquiera que haya quedado pegado
// de una versión anterior (el sw.js que existió acá tenía la URL del
// backend hardcodeada y una regla de cache que intentaba cachear respuestas
// de POST, rompiendo requests reales cada vez que esa URL quedaba
// desactualizada) — sin este desregistro explícito, un navegador que ya
// instaló ese worker seguiría usándolo indefinidamente.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
}

reportWebVitals();
